var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("jet-action-section", {
    scopedSlots: _vm._u([
      {
        key: "title",
        fn: function () {
          return [_vm._v(" Browser Sessions ")]
        },
        proxy: true,
      },
      {
        key: "description",
        fn: function () {
          return [
            _vm._v(
              "\n    Manage and logout your active sessions on other browsers and devices.\n  "
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "content",
        fn: function () {
          return [
            _c("div", { staticClass: "max-w-xl text-sm text-gray-600" }, [
              _vm._v(
                "\n      If necessary, you may logout of all of your other browser sessions\n      across all of your devices. If you feel your account has been\n      compromised, you should also update your password.\n    "
              ),
            ]),
            _vm._v(" "),
            _vm.sessions.length > 0
              ? _c(
                  "div",
                  { staticClass: "mt-5 space-y-6" },
                  _vm._l(_vm.sessions, function (session) {
                    return _c(
                      "div",
                      { key: session, staticClass: "flex items-center" },
                      [
                        _c("div", [
                          session.agent.is_desktop
                            ? _c(
                                "svg",
                                {
                                  staticClass: "w-8 h-8 text-gray-500",
                                  attrs: {
                                    fill: "none",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                    "stroke-width": "2",
                                    viewBox: "0 0 24 24",
                                    stroke: "currentColor",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z",
                                    },
                                  }),
                                ]
                              )
                            : _c(
                                "svg",
                                {
                                  staticClass: "w-8 h-8 text-gray-500",
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    viewBox: "0 0 24 24",
                                    "stroke-width": "2",
                                    stroke: "currentColor",
                                    fill: "none",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M0 0h24v24H0z",
                                      stroke: "none",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("rect", {
                                    attrs: {
                                      x: "7",
                                      y: "4",
                                      width: "10",
                                      height: "16",
                                      rx: "1",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("path", {
                                    attrs: { d: "M11 5h2M12 17v.01" },
                                  }),
                                ]
                              ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "ml-3" }, [
                          _c("div", { staticClass: "text-sm text-gray-600" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(session.agent.platform) +
                                " -\n            " +
                                _vm._s(session.agent.browser) +
                                "\n          "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _c(
                              "div",
                              { staticClass: "text-xs text-gray-500" },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(session.ip_address) +
                                    ",\n\n              "
                                ),
                                session.is_current_device
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "text-green-500 font-semibold",
                                      },
                                      [_vm._v("This device")]
                                    )
                                  : _c("span", [
                                      _vm._v(
                                        "Last active " +
                                          _vm._s(session.last_active)
                                      ),
                                    ]),
                              ]
                            ),
                          ]),
                        ]),
                      ]
                    )
                  }),
                  0
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex items-center mt-5" },
              [
                _c(
                  "jet-button",
                  {
                    nativeOn: {
                      click: function ($event) {
                        return _vm.confirmLogout.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v("\n        Logout Other Browser Sessions\n      ")]
                ),
                _vm._v(" "),
                _c(
                  "jet-action-message",
                  {
                    staticClass: "ml-3",
                    attrs: { on: _vm.form.recentlySuccessful },
                  },
                  [_vm._v("\n        Done.\n      ")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("jet-dialog-modal", {
              attrs: { show: _vm.confirmingLogout },
              on: {
                close: function ($event) {
                  _vm.confirmingLogout = false
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "title",
                  fn: function () {
                    return [_vm._v(" Logout Other Browser Sessions ")]
                  },
                  proxy: true,
                },
                {
                  key: "content",
                  fn: function () {
                    return [
                      _vm._v(
                        "\n        Please enter your password to confirm you would like to logout of your\n        other browser sessions across all of your devices.\n\n        "
                      ),
                      _c(
                        "div",
                        { staticClass: "mt-4" },
                        [
                          _c("jet-input", {
                            ref: "password",
                            staticClass: "mt-1 block w-3/4",
                            attrs: {
                              type: "password",
                              placeholder: "Password",
                            },
                            nativeOn: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                )
                                  return null
                                return _vm.logoutOtherBrowserSessions.apply(
                                  null,
                                  arguments
                                )
                              },
                            },
                            model: {
                              value: _vm.form.password,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "password", $$v)
                              },
                              expression: "form.password",
                            },
                          }),
                          _vm._v(" "),
                          _c("jet-input-error", {
                            staticClass: "mt-2",
                            attrs: { message: _vm.form.errors.password },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "footer",
                  fn: function () {
                    return [
                      _c(
                        "jet-secondary-button",
                        {
                          nativeOn: {
                            click: function ($event) {
                              _vm.confirmingLogout = false
                            },
                          },
                        },
                        [_vm._v("\n          Nevermind\n        ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "jet-button",
                        {
                          staticClass: "ml-2",
                          class: { "opacity-25": _vm.form.processing },
                          attrs: { disabled: _vm.form.processing },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.logoutOtherBrowserSessions.apply(
                                null,
                                arguments
                              )
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n          Logout Other Browser Sessions\n        "
                          ),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }